@switch (menuStyle()) {
  @case (TabMenuStyle.RUNNER) {
    <span
      [ngClass]="menuStyle()"
      class="tab-button-link"
      [routerLink]="item().url"
      [queryParams]="item().queryParams"
      [queryParamsHandling]="item().queryParamHandling || queryParamHandling()"
      [routerLinkActiveOptions]="{ exact: false }"
      [replaceUrl]="replaceURL()"
      routerLinkActive="active"
      (click)="itemClick.emit(item())"
    >
      <twc-tab-menu-item
        [item]="item()"
        [menuItemArgument]="menuItemArgument()"
      />
    </span>
  }
  @default {
    <a
      [ngClass]="menuStyle()"
      matRipple
      class="tab-button-link mr-2"
      [routerLink]="item().url"
      [queryParams]="item().queryParams"
      [queryParamsHandling]="item().queryParamHandling || queryParamHandling()"
      [routerLinkActiveOptions]="{ exact: false }"
      [replaceUrl]="replaceURL()"
      routerLinkActive="active"
      (click)="itemClick.emit(item())"
    >
      <twc-tab-menu-item
        [item]="item()"
        [menuItemArgument]="menuItemArgument()"
      />
    </a>
  }
}
